import React from "react";

export const Logo = ({ size = 48 }) => (
  <div
    className="relative flex items-center justify-center"
    style={{ width: size, height: size }}
    data-testid="brand-logo"
  >
    <svg viewBox="0 0 48 48" width={size} height={size} fill="none">
      <defs>
        <linearGradient id="goldg" x1="0" y1="0" x2="48" y2="48">
          <stop offset="0%" stopColor="#F7E6B4" />
          <stop offset="50%" stopColor="#D4A845" />
          <stop offset="100%" stopColor="#B8902F" />
        </linearGradient>
      </defs>
      <circle cx="24" cy="24" r="22" stroke="url(#goldg)" strokeWidth="1.5" fill="rgba(230,180,85,0.06)" />
      <path
        d="M15 18 Q24 10 33 18 L33 30 Q24 38 15 30 Z"
        stroke="url(#goldg)"
        strokeWidth="1.8"
        strokeLinejoin="round"
        fill="none"
      />
      <text
        x="24"
        y="29"
        textAnchor="middle"
        fontFamily="Outfit, sans-serif"
        fontSize="13"
        fontWeight="700"
        fill="url(#goldg)"
      >
        OP
      </text>
    </svg>
  </div>
);
